module.exports = __webpack_public_path__ + "img/nigeria.ff496da5.svg";